import styled from "styled-components";

export const Wrapper = styled.div`
  .button-container {
    display: flex;
  }

`;
